// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"91":"0dffb57325612553","185":"88e10e97cd42420d","421":"0dffb57325612553"}[chunkId] + ".css";
};